
$(document).on('click','.back_to_the_top_icon', function(){
    $('html, body').animate({
        scrollTop: $("html").offset().top
    }, 1200);
});




$(document).on('click','.site-filters-wrapper .site-filters', function(){
  $(this).parents('.site-filters-wrapper').find('.site-filters').removeClass('filter-active');
  $(this).addClass('filter-active');
  var m_parent =$(this).parents('.section-single-banner');
  var m_this =$(this).attr('data-handlize');
  if(m_this == 'all'){
    m_parent.find('.ap-repeater').removeClass('filter-hidden');     
  }
  else{
    m_parent.find('.ap-repeater').addClass('filter-hidden'); 
    m_parent.find('.ap-repeater[data-handleize="'+m_this+'"]').removeClass('filter-hidden');    
  }
  var total = m_parent.find('.ap-repeater').length;
  var hidden = m_parent.find('.filter-hidden').length;
     if(total == hidden){
       m_parent.find('.no-products').addClass('noproduct-shown');
     }
  else{
       m_parent.find('.no-products').removeClass('noproduct-shown');    
  }
    $('html, body').animate({
        scrollTop: $('.products-wrapper').offset().top - 150
    }, 1200);
});


$(document).ready(function(){
  $(document).on('click','.op-Frame label', function(){
      var m_parent =$(this).parents('.variant-picker-with-atc');
      var id = m_parent.find('.optionname-Frame select').attr('id');
      var get_val = $(this).attr('data-value');
      var selectElement = document.getElementById(id);
      selectElement.value = get_val;
      var event = new Event("change", { bubbles: true });
      selectElement.dispatchEvent(event);
      var frame = $(this).attr('data-frame');
      $(this).parents('.variant-picker-with-desc').find('.frame-popup-left .room-bg-img div').removeClass();
      $(this).parents('.variant-picker-with-desc').find('.frame-popup-left .room-bg-img div').addClass('p-img').addClass(frame);
      var size = $(this).parents('.variant-picker-with-atc').find('.optionname-Size select option:selected').val();
      var size = size.replace(/"|'/g,'');
      var size = size.replace('x','');
      var size = 'size-'+size;
      $(this).parents('.variant-picker-with-desc').find('.frame-popup-left .room-bg-img div').addClass(size);
      $(this).parents('.variant-picker-with-desc').find('.frame-popup-left .room-bg-img').removeClass().addClass('room-bg-img').addClass(size);
  });

  $(document).on('change', '.optionname-Size select', function() {
      var original_size = $(this).find('option:selected').val();
      var size = $(this).find('option:selected').val();
      var size = size.replace(/"|'/g,'');
      var size = size.replace('x','');
      var size = 'size-'+size;
      var frame  = $(this).parents('.variant-picker-with-atc').find('.op-Frame input[type=radio]:checked+label').attr('data-frame');    
      $(this).parents('.variant-picker-with-desc').find('.frame-popup-left .room-bg-img div').removeClass();    
      $(this).parents('.variant-picker-with-desc').find('.frame-popup-left .room-bg-img div').addClass('p-img').addClass(frame).addClass(size);
      $(this).parents('.variant-picker-with-desc').find('.frame-popup-left .room-bg-img').removeClass().addClass('room-bg-img').addClass(size);

      // setImageSize(size)
      size_text(original_size);
  });
    function size_text(original_size){
       if(original_size == '40x60"'){
          $('.variant-picker-with-atc').find('.data-frame-size-text').text('*40x60" print size / 42.5" x 62.5" finished frame size (does not include mat).');             
       }
       if(original_size == '24x36"'){
          $('.variant-picker-with-atc').find('.data-frame-size-text').text('*24x36" print size / 30.5" x 42.5" finished frame size (includes mat).');
       }
       if(original_size == '12x18"'){
          $('.variant-picker-with-atc').find('.data-frame-size-text').text('*12x18" print size / 17.5" x 23.5" finished frame size (includes mat).');                                
       }
    }

    // function setImageSize(size){

    // }
  setTimeout(function(){
    var original_size = $('.optionname-Size select option:selected').val();
    // console.log(original_size);
    size_text(original_size);
    // $('.op-Frame input:checked+label').trigger('click');
    var frame = $('.product-form__input input[type=radio]:checked+label').attr('data-frame');
    // console.log(frame);
    $('.variant-picker-with-desc').find('.frame-popup-left .room-bg-img div').removeClass().addClass('p-img').addClass(frame);
    var size = $('.variant-picker-with-atc').find('.optionname-Size select option:selected').val();
    var size = size.replace(/"|'/g,'');
    var size = size.replace('x','');
    var size = 'size-'+size;
    $('.variant-picker-with-desc').find('.frame-popup-left .room-bg-img').addClass(size).css('opacity', 1);
    $('.variant-picker-with-desc').find('.frame-popup-left .room-bg-img div').addClass(size).css('opacity', 1);
  }, 1000);


  $(document).on('click','.variant-picker-with-atc button.button', function(){
    $('body').addClass('frame-popup-show');
    $('.product__info-wrapper').removeClass('animate--slide-in');
  });
  $(document).on('click','.frame-popup-close, .frame-close svg', function(){
    $('body').removeClass('frame-popup-show');
    $('.product__info-wrapper').addClass('animate--slide-in');
  });


  $('.fav-products').slick({
  slidesToShow: 9,
  slidesToScroll: 9,
  prevArrow:'<button type="button" class="slick-custom-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="8.94" height="14.028" viewBox="0 0 8.94 14.028"><path d="M7.893,8.94,0,0H6.181V1.446H3.2L7.852,6.709l4.306-5.263h1.87Z" transform="translate(8.94) rotate(90)" fill="#e4e4e4"/></svg></button>',
  nextArrow:'<button type="button" class="slick-custom-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="8.94" height="14.028" viewBox="0 0 8.94 14.028"><path d="M7.893,0,0,8.94H6.181V7.494H3.2L7.852,2.231l4.306,5.263h1.87Z" transform="translate(8.94) rotate(90)" fill="#e4e4e4"/></svg></button>',
  dots: false,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        centerMode: true,
        slidesToScroll: 7,
        slidesToShow: 7
      }
    },
    {
      breakpoint: 1025,
      settings: {
        centerMode: true,
        slidesToScroll: 5,
        slidesToShow: 5
      }
    },
    {
      breakpoint: 991,
      settings: {
        centerMode: true,
        slidesToScroll: 4,
        slidesToShow: 4
      }
    },
    {
      breakpoint: 769,
      settings: {
        centerMode: true,
        slidesToScroll: 3,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 575,
      settings: {
        centerMode: true,
        slidesToScroll: 2,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 374,
      settings: {
        centerMode: true,
        slidesToScroll: 1,
        slidesToShow: 1
      }
    }
  ]
});

  

 $(window).scroll(function(){
     if($('div').hasClass('site-filters')){
      var get_top = $('section#shopify-section-sections--16215834984627__4d74e24a-58df-4529-8901-592335b5a800').offset().top - 250;
      if ($(window).scrollTop() > get_top){
        $('body').addClass('hide-fixed-filter');
      }
      else{
        $('body').removeClass('hide-fixed-filter');
      }       
     }
    });
});